"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalBentoLib = exports.globalBentoLib = void 0;
var window_service_1 = require("../../window-service");
var defaultBentoLib = {
    onNewPage: function () { return undefined; },
};
var getBento = function () {
    return window_service_1.windowService.getWindow().Bento || defaultBentoLib;
};
var onNewPage = function (config) {
    getBento().onNewPage(config);
};
exports.globalBentoLib = {
    onNewPage: onNewPage,
};
var GlobalBentoLib = /** @class */ (function () {
    function GlobalBentoLib() {
        return exports.globalBentoLib;
    }
    return GlobalBentoLib;
}());
exports.GlobalBentoLib = GlobalBentoLib;
